module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Bold.54389498.eot";